
export const checkIfTestUnlocked = (testSettings, individual, moneyMgmtTestArr) => {
    // if individual is false (player is assigned to an account)
    //      test is unlocked if the current test setting is "mid-test" ... OR ...
    //      the current test setting has not already been taken ...  OR ...
    // if player is not associated with an account (no test settings found)
    //      test is unlocked if no test has been taken (type is pre-test) ....OR...
    //      test is unlocked if pre-test exists but no post-test has been taken
    //      NOTE:  mid-tests are not valid in this case.
    let newTestType = testSettings.testType;
    let testUnlocked = false;
    let testTypeArr = [];
    for (let i=0; i<moneyMgmtTestArr.length; i++){
        const testType = moneyMgmtTestArr[i].testType;
        testTypeArr.push(testType);
    }
    if (testTypeArr.includes("none")){
        testUnlocked = true;
    }else{
        if ((!testTypeArr.includes("post-test") && newTestType === "post-test") ||
            individual === true){
            testUnlocked = true;
            if (individual === true){
                newTestType = "post-test";
            }
        }else{
            if (newTestType === "mid-test"){
                testUnlocked = true;
            }
        }
    }
    
    const returnObj={testUnlocked: testUnlocked, testType: newTestType};
    return returnObj;

}
export default checkIfTestUnlocked;